<template>
    <div class="news-card">
        <div class="header">
            <div :class="{ show: !read }" class="new"></div>
            <Avatar :icon="value.eventType" class="avatar" />
            <div class="name-news">{{ mapEventTypes[value.eventType] }}</div>
            <div class="date">{{ value.eventDate | dateFormat }}</div>
        </div>

        <div class="info">
            <router-link :to="{ name: 'product', params: { id: value.productId } }"
                         class="title"
                         @click.native="onGoToCard">
                {{ value.productName }}
            </router-link>

            <ShowMore ref="showMore"
                      :maxHeight="60"
                      :value="description"
                      class="description"
                      @toggle="showMore = !showMore" />
        </div>

        <template v-if="showDocuments">
            <Attachment v-for="(it, id) in value.newDocuments"
                        :key="id"
                        :value="it"
                        class="attachment"
                        @download="downloadDocument(it)"
            />
        </template>

        <div class="footer">
            <button v-if="!favorite" class="no-border iconed subscribe" @click="favoriteSub">
                <IconFavoriteOutline class="icon" />
                <span class="text">В избранное</span>
            </button>
            <button v-else class="no-border iconed subscribe" @click="favoriteUnsub">
                <IconFavoriteSolid class="icon " />
                <span class="text">В избранном</span>
            </button>
        </div>
    </div>
</template>

<script>
import { favoriteSub, favoriteUnsub } from '@/common/page_comp/Favorite/util.js';
import dateFormat from '@dsee/components/filters/dateFormat.js';
import Timer from '@dsee/util/timer.js';
import Avatar from './common/Avatar.vue';

import IconFavoriteOutline from './icons/favorite_outline.svg?component';
import IconFavoriteSolid from './icons/favorite_solid.svg?component';

export default {
    name: 'CardNews',
    components: {
        IconFavoriteOutline,
        IconFavoriteSolid,
        Avatar,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        mapEventTypes: {
            type: Object,
            required: true,
        },
        subscriptionConfig: {
            type: Object,
            default: () => null,
        },
    },
    data() {
        return {
            showMore: false,
            showMoreButton: false,
            favorite: false,
            read: false,
        };
    },
    computed: {
        description() {
            let lines = [];

            if (this.value.newCreated)
                lines.push(`Добавлен продукт «${ this.value.productName }».`);

            // if (this.value.highRated)
            //     lines.push(`У нового продукта быстро растет популярность. Обратите внимание.`);
            //
            // if (this.value.topViewed)
            //     lines.push(`По итогам расчетов карточка попала в топ самых популярных.`);

            if (this.value.newStatus)
                lines.push(`Продукт перешел в статус «${ this.value.newStatus.name }».`);

            if (this.value.newPilots.length)
                lines.push(`Важная новость - появилась информация о пилотном внедрении продукта.`);

            // if (this.value.newOffice) {
            //     const { name, id, cluster } = this.value.newOffice;
            //     if (!cluster?.name)
            //         return;
            //
            //     lines.push(
            //         `Продукт переведен в ${ nameToLowerCase(cluster?.name) }
            //         (<a href="/office/${ id }">${ name }</a>).`,
            //     );
            // }
            //
            // if (this.value.tagChanged)
            //     lines.push(`В продукте изменились теги.`);

            if (this.value.newDocuments.length) {
                const documents = this.value.newDocuments.map((it) => `«${ it.name }»`).join(', ');

                const textDocument = (this.value.newDocuments.length > 1 ?
                    'К продукту добавлены файлы ' :
                    'К продукту добавлен файл ');

                lines.push(textDocument + documents);
            }

            return lines.join('<br><br>');
        },
        showDocuments() {
            return this.value.newDocuments.length !== 0 && (this.showMore || !this.showMoreButton);
        },
        subscriptionActive() {
            return this.subscriptionConfig?.active ?? false;
        },
    },
    filters: {
        dateFormat(dateCard) {
            const today = new Date();
            let yesterday = new Date();
            yesterday = yesterday.setDate(today.getDate() - 1);

            switch (dateCard) {
                case dateFormat(today, 'iso.date'):
                    return 'Сегодня';
                case dateFormat(yesterday, 'iso.date'):
                    return 'Вчера';
                default:
                    return dateFormat(dateCard, 'rus.date');
            }
        },
    },
    created() {
        this.favorite = this.value.subscribed;
        this.read = this.value.viewed;
    },
    mounted() {
        const options = {
            root: this.$parent.$parent.$el,
            rootMargin: '0px',
            threshold: 0.2,
        };

        const observer = this.$options.observer = new IntersectionObserver(this.onRead, options);
        observer.observe(this.$el);

        this.$nextTick(() => {
            this.showMoreButton = this.$refs.showMore.showButton;
        });
    },
    destroyed() {
        this.$options.observer.disconnect();
    },
    methods: {
        favoriteSub() {
            favoriteSub(this.value.productId, this);
        },
        favoriteUnsub() {
            favoriteUnsub(this.value.productId, this);
        },
        downloadDocument(file) {
            window.open(`/api/document/load/` + file.id, '_blank');
        },
        onRead([ entry ]) {
            if (entry.isIntersecting && !this.read) {
                this.$emit('read', this.value.id);

                const timer = new Timer();
                timer.setTimeout(() => {
                    this.read = true;
                }, 10000);
            }
        },
        onGoToCard() {
            this.$emit('closeModal');

            // метрика
            try {
                this.$metrika.reachGoal('from_news');
            } catch (e) {
                console.error('Не удалось отправить метрику: ' + e);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.news-card {
    border-top: 1px solid rgba(16, 24, 40, 0.1);
    padding-top: 20px;
    padding-bottom: 32px;
    .header {
        display: flex;
        align-items: center;
        margin-left: 8px;

        .new {
            margin-left: -8px;
            width: 5px;
            height: 5px;
            background-color: #FF0000;
            border-radius: 50%;

            &:not(.show) {
                visibility: hidden;
            }
        }

        .avatar {
            margin-left: 8px;
        }

        .name-news {
            margin-left: 8px;
            font-weight: 500;
            font-size: 14px;
        }

        .date {
            margin-left: 8px;
            color: rgba(16, 24, 40, 0.6);
            font-size: 12px;
        }
    }

    .info {
        margin-left: 16px;

        .title {
            margin-top: 25px;
            font-weight: 700;
            font-size: 18px;
            line-height: 24px;
            margin-bottom: 8px;
            color: #101828;
            max-width: 100%;
            white-space: wrap;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }

        .description {
            margin-bottom: 20px;

            :deep(button) {
                margin-top: 10px;
            }
        }
    }

    .footer {
        margin-left: 16px;
        display: flex;
        align-items: center;


        .subscribe {

        }
    }

    .attachment {
        margin-bottom: 20px;
    }
}
</style>
